import React from 'react';
import { Accordion } from 'react-bootstrap';
import { camelCaseToTileCase } from '~/lib/cases';
const AccordionCollapse = ({ doc, metadata }) => {
    return (React.createElement(Accordion.Collapse, { eventKey: `${doc.id}-id`, style: { height: 'auto' } },
        React.createElement(React.Fragment, null, metadata.metadataFields.map((metadataField) => {
            return (React.createElement("div", { className: 'parent-metadata-container', key: metadataField.name },
                React.createElement("h6", { className: 'parent-metadata' }, camelCaseToTileCase(metadataField.name)),
                Array.isArray(metadataField.value)
                    ? metadataField.value.map((item, i) => React.createElement("div", { key: i }, item))
                    : React.createElement("div", null, metadataField.value)));
        }))));
};
export default AccordionCollapse;
